import { RelationshipType } from '@common/entities';

import { useApplicationSettings } from 'hooks/useApplicationSettings';
import { useGetApplicantRelationship } from 'hooks/useGetApplicantRelationship';

export interface PersonalInfoFieldRules {
  relationshipType: RelationshipType;
  minAge: number;
  isAdult: boolean;
  requiresContactInfo: boolean;
  requiresEmail: boolean;
}

/**
 * Visibility/validation rules for the Personal Information block, kept out of the component
 * so they stay testable in isolation.
 */
export const usePersonalInfoFieldRules = (): PersonalInfoFieldRules => {
  const {
    getApplicantRelationship,
    getApplicantRequiresContactInfo,
    getApplicantRequiresEmail,
    getApplicantIsAdult,
  } = useGetApplicantRelationship();

  const relationshipType = getApplicantRelationship();
  const { minAge } = useApplicationSettings(relationshipType);

  const isAdult = getApplicantIsAdult();
  const requiresContactInfo = getApplicantRequiresContactInfo(isAdult);
  const requiresEmail = getApplicantRequiresEmail(isAdult);

  return { relationshipType, minAge, isAdult, requiresContactInfo, requiresEmail };
};
